module.exports = __webpack_public_path__ + "img/paypal_icon.5baf011.png";